export interface ICursorPosition {
  x: number;
  y: number;
}

// Допустимая погрешность при детекте клика (px)
const POSSIBLE_INACCURACY = 3;

export function isClick(oldPoint: ICursorPosition, newPoint: ICursorPosition) {
  const { x: oldX, y: oldY } = oldPoint;
  const { x, y } = newPoint;

  return Math.abs(x - oldX) <= POSSIBLE_INACCURACY && Math.abs(y - oldY) <= POSSIBLE_INACCURACY;
}
